import {configureStore} from "@reduxjs/toolkit";
import {combineReducers} from "redux";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {authSlice} from "./authSlice";
import {uiSlice} from "./uiSlice";
import {dataSlice} from "./dataSlice";

// const rootReducer = combineReducers({
//   [authSlice.name]: authSlice.reducer,
//   [uiSlice.name]: uiSlice.reducer,
//   [dataSlice.name]: dataSlice.reducer,
// });

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    storage.removeItem("persist:root");
    return combineReducers({
      [authSlice.name]: authSlice.reducer,
      [uiSlice.name]: uiSlice.reducer,
      [dataSlice.name]: dataSlice.reducer,
    })(undefined, action);
  }

  return combineReducers({
    [authSlice.name]: authSlice.reducer,
    [uiSlice.name]: uiSlice.reducer,
    [dataSlice.name]: dataSlice.reducer,
  })(state, action);
};

const persistConfig = {
  key: "root",
  whitelist: [authSlice.name, uiSlice.name, dataSlice.name], // Specify which slices to persist
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Redux store
const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer here
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false, // Disable serializableCheck for redux-persist compatibility
    }),
});

// Create persistor instance to handle persistence
const persistor = persistStore(store);

export {store, persistor};
